export class UndoManager {
  constructor(texturePainter, options = {}) {
    this.texturePainter = texturePainter;
    this.maxStates = typeof options.maxStates === 'number' ? Math.max(1, options.maxStates) : 30;
    this.stack = [];
  }

  pushCheckpoint() {
    if (!this.texturePainter?.uvChannels?.length) return;

    const states = {};
    this.texturePainter.uvChannels.forEach((channel, index) => {
      if (channel?.decalCanvas) {
        const backup = document.createElement('canvas');
        backup.width = channel.decalCanvas.width;
        backup.height = channel.decalCanvas.height;
        const bctx = backup.getContext('2d');
        bctx.drawImage(channel.decalCanvas, 0, 0);
        states[index] = backup;
      }
    });

    if (Object.keys(states).length === 0) return; // nothing to store

    this.stack.push(states);
    if (this.stack.length > this.maxStates) {
      this.stack.shift();
    }
  }

  // Undo last atomic operation.
  undo() {
    if (!this.stack.length) {
      this.texturePainter?.updateStatus?.('Nothing to undo');
      return;
    }

    const last = this.stack.pop();

    Object.keys(last).forEach((indexStr) => {
      const idx = parseInt(indexStr, 10);
      const channel = this.texturePainter.uvChannels[idx];
      const backupCanvas = last[idx];
      if (!channel?.decalCanvas || !backupCanvas) return;

      const ctx = channel.decalContext || channel.decalCanvas.getContext('2d', { willReadFrequently: true });
      channel.decalContext = ctx;

      ctx.clearRect(0, 0, channel.decalCanvas.width, channel.decalCanvas.height);
      ctx.drawImage(backupCanvas, 0, 0);

      if (typeof this.texturePainter.compositeTexture === 'function') {
        this.texturePainter.compositeTexture(idx);
      }
    });

    this.texturePainter?.refreshCharacterMaterials?.();
    this.texturePainter?.updateStatus?.('Undo applied');
  }
}
